var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        id: "request",
        title: "CUONAを追加する",
        width: "35%",
        "custom-class": "requestDialog",
        visible: _vm.isShowingDialog,
      },
      on: {
        "update:visible": function ($event) {
          _vm.isShowingDialog = $event
        },
        closed: _vm.closedCuonaRequestDialog,
      },
    },
    [
      _c("div", { staticClass: "request-content" }, [
        _c(
          "div",
          { attrs: { id: "cube" } },
          [
            _c("img", { attrs: { src: _vm.images.cube } }),
            _c("h2", [_vm._v("CUONA CUBE")]),
            _c("el-input-number", {
              attrs: { size: "mini", min: 0 },
              model: {
                value: _vm.cuonaRequestDialogForm.cube.count,
                callback: function ($$v) {
                  _vm.$set(_vm.cuonaRequestDialogForm.cube, "count", $$v)
                },
                expression: "cuonaRequestDialogForm.cube.count",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { attrs: { id: "tag" } },
          [
            _c("img", { attrs: { src: _vm.images.tag } }),
            _c("h2", [_vm._v("CUONA TAG")]),
            _c("el-input-number", {
              attrs: { size: "mini", min: 0 },
              model: {
                value: _vm.cuonaRequestDialogForm.tag.count,
                callback: function ($$v) {
                  _vm.$set(_vm.cuonaRequestDialogForm.tag, "count", $$v)
                },
                expression: "cuonaRequestDialogForm.tag.count",
              },
            }),
          ],
          1
        ),
      ]),
      _c(
        "footer",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              staticClass: "add_request",
              attrs: { type: "primary" },
              on: { click: _vm.requestDevice },
            },
            [_vm._v("追加申請する")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }